import { render, staticRenderFns } from "./Flame.vue?vue&type=template&id=44b935ec&scoped=true&"
var script = {}
import style0 from "./Flame.vue?vue&type=style&index=0&id=44b935ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b935ec",
  null
  
)

export default component.exports